import { FeatureFlag } from '@ps/web-core-enums';
import { useEffect, useState } from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { useFeature } from '../../../../../../../../libs/core/store/src/lib/hooks/useFeature';
import createSingleton from '../../../hooks/useSingleton';

import useRmfFirstScreen from './useRmfFirstScreen';

const [getValue, setValue] = createSingleton<string | undefined>(undefined);

type ReturnValue = [boolean | undefined, () => void];

const useTransitionScreenHandler = (additionalCondition = false): ReturnValue => {
  const [isTransitionVisible, setTransitionVisibility] = useState<boolean>();
  const isFirstScreen = useRmfFirstScreen();
  const userIdWhoClosedTransitionScreen = getValue();
  const swcDisableSignupTransition = useFeature(FeatureFlag.SwcDisableSignupTransition);

  const {
    data: { signupPassed },
    values: { userId }
  } = useWizardContext();

  const hasBeenShown = userId && userIdWhoClosedTransitionScreen === userId;
  useEffect(() => {
    if (isFirstScreen !== undefined) {
      const defaultCondition = !swcDisableSignupTransition && signupPassed && isFirstScreen;
      setTransitionVisibility((defaultCondition || additionalCondition) && !hasBeenShown);
    }
  }, [signupPassed, isFirstScreen, hasBeenShown, additionalCondition, swcDisableSignupTransition]);

  const closeTransitionScreen = (): void => {
    if (userId) {
      setValue(userId);
    }
    setTransitionVisibility(false);
  };

  return [isTransitionVisible, closeTransitionScreen];
};

export default useTransitionScreenHandler;
